export default __webpack_public_path__ + "6260d8bf60d44fbe81bc63c80ee9c501.svg";